export enum AchievementStatus {
	Draft = 1,
	AvailableUnlocked = 2,
	AvailableLocked = 3,
	Archived = 4,
	FeaturedManually = 5,
	FeaturedAI = 6,
	Recurring = 7,
	RecurringUponCompletion = 8
}
